<template>
  <ds-table
    :fields="memberFields"
    :items="members"
    :busy="loading"
    busy-text="Loading members…"
    empty-text="No members found."
  >
    <template #cell(effectiveRole)="{ value }">
      <ds-badge :variant="value === 'admin' ? 'accent' : 'neutral'">
        <template v-if="value">
          {{ value }}
        </template>
        <template v-else>
          <span aria-hidden="true">-</span><span class="sr-only">Not set</span>
        </template>
      </ds-badge>
    </template>
  </ds-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { DsBadge, DsTable } from '@/design-system/components'
import { organizationService } from '@/_services'
import { cOrganizationMember } from '@/_models/index'

export default {
  name: 'OrganizationMembers',
  components: {
    DsBadge,
    DsTable,
  },
  data() {
    return {
      loading: false,
      members: [],
      memberFields: [
        { key: 'firstName', label: 'First name' },
        { key: 'lastName', label: 'Last name' },
        { key: 'email', label: 'Email' },
        { key: 'effectiveRole', label: 'Role' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      organization: 'authentication/organization',
    }),
  },
  watch: {
    // The partner resolves asynchronously; without this the first (empty) attempt was the
    // only one and the table sat on "No members found." forever.
    'organization.id': {
      immediate: true,
      handler() {
        this.loadMembers()
      },
    },
  },
  methods: {
    loadMembers() {
      if (!this.organization || !this.organization.id) {
        return
      }
      this.loading = true
      organizationService.getMembers(this.organization.id)
        .then(response => {
          this.members = (response.data || []).map(member => cOrganizationMember.fromJSON(member))
        })
        .catch(error => {
          this.$notify.error(`Failed to load members: ${error.message || 'Unknown error'}`)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
